import { FunctionComponent, Fragment } from 'react'

import { LightHeader } from '../../components/LightHeader'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import useStyles from './styles'
import { ConfirmPassword } from '../../components/ConfirmPassword'
import { useHistory } from 'react-router'
import { setCache } from '@/utils/cache'
import { Text } from '@conexasaude/conexa-hero'
import { RenderIf } from '@/components/RenderIf'
import TimeZoneLuxon from '@/components/TimeZoneLuxon'

const ChangePassword: FunctionComponent = () => {
  const { clinic, user } = useAuthContext()
  const styles = useStyles()
  const { push } = useHistory()
  const handleConfirm = () => {
    setCache('passwordConfirmed', true)
    push('/trocar-senha')
  }

  return (
    <Fragment>
      <LightHeader uniqueCode={clinic.uniqueCode} redirectTo="/" />
      <div css={styles.container}>
        <div css={styles.changePasswordNoise}></div>
        <ConfirmPassword onConfirm={() => handleConfirm()} />
        <div css={styles.timeZoneSection}>
          <TimeZoneLuxon />
          <RenderIf condition={Boolean(user?.patientId)}>
            <Text renderAs="p" variant="microCopy">
              ID: {user?.patientId} | Clínica: {user.clinic?.name}
            </Text>
          </RenderIf>
        </div>
      </div>
    </Fragment>
  )
}

export default ChangePassword
